import React from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography, { typographyClasses } from "@mui/material/Typography";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import {  useTheme } from "@mui/material/styles";

import MHFooter from "../components/Layout/MHFooter";
import MHSubscribe from "../components/Layout/MHSubscribe";
import RegDialog from "../components/Summit/RegDialog";
import MHButton from "../components/Common/Button/MHButton";
// import { useHistory } from "react-router-dom";

const BlankEvent = () => {
  // const theme = useTheme();
  // const matchesMdDown = useMediaQuery(theme.breakpoints.down("md"));

  // const history = useHistory();

  // const membershipPlansDivRef = React.useRef<{
  //   divEl: HTMLDivElement | null;
  // }>({ divEl: null });

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Grid container direction={{ xs: "column", md: "row" }} mb={4}>
        <Grid item xs={12} md={6} bgcolor="#F3F4F6">
          <Stack
            height={500}
            justifyContent="center"
            alignItems="center"
            px={{ xs: 2, md: 10 }}
            sx={{
              "& > p": {
                textAlign: "center",
                pointerEvents: "none",
              },
            }}
          >
            <Typography
              variant="caption"
              textTransform="uppercase"
              fontSize="11px"
              letterSpacing="0.1em"
              lineHeight="230%"
              sx={{
                mb: 5,
              }}
              paragraph
            >
              Event
            </Typography>

            <Typography
              variant="h1"
              fontSize={{ xs: "30px", sm: "40px", md: "40px" }}
              textTransform="capitalize"
              sx={{
                mb: 4,
              }}
              paragraph
            >
              Building Nigeria's Care Infrastructure
            </Typography>

            <Typography
              variant="body1"
              align="center"
              color="#194049"
              fontSize="13px"
              lineHeight="185%"
              letterSpacing="0.02em"
              sx={{
                mb: 4,
              }}
              paragraph
            >
              Advancing Families and Catalyzing Economic Growth
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              color="#194049"
              fontSize="13px"
              lineHeight="185%"
              letterSpacing="0.02em"
              sx={{
                mb: 4,
              }}
              paragraph
            >
              <b className=" font-areaBlack">
                New York, NY | September 23, 2025
                <br />
                9:00 - 11:00AM
              </b>
            </Typography>

            <Box className="pl-2 ">
              <MHButton
                onClick={handleOpen}
                sx={{ width: "210px", height: "52px" }}
                color="primary"
                className="text-xs"
              >
                Register Now
              </MHButton>
            </Box>

            {/* <MHButton
              sx={{
                width: "fit-content",
              }}
              onClick={() =>
                membershipPlansDivRef.current?.divEl?.scrollIntoView({
                  behavior: "smooth",
                })
              }
            >
              More Info
            </MHButton> */}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              "& > img": {
                height: 600,
                width: "100%",
                objectPosition: "bottom",
                objectFit: "cover",
              },
            }}
          >
            <img
              src="https://mh-resources-production.s3.us-west-1.amazonaws.com/conference.jpg"
              alt="Banner"
              width="700"
            />
          </Box>
        </Grid>
      </Grid>

      <Box
        py={5}
        px={{ xs: 2, md: 6, lg: 8 }}
        color="primary.main"
        sx={{
          [`& > .${typographyClasses.root}`]: {
            // color: '#EDD5B1',
            textAlign: "center",
          },
        }}
      >
        <Typography
          variant="h1"
          fontSize={{ xs: "20px", md: "50px" }}
          lineHeight="120.5%"
          letterSpacing="-0.04em"
          mb={2}
        >
          Nigeria’s care infrastructure, care economy, <br /> and care policy
          agenda.
        </Typography>

        <Typography
          variant="body2"
          fontSize={{ xs: "13px", md: "18px" }}
          lineHeight={{ xs: "200%", md: "169%" }}
          letterSpacing="0.02em"
          width={{ xs: "90%", md: "80%" }}
          mx="auto"
          mb={4}
        >
          This gathering will bring together{" "}
          <b className=" font-areaBlack">
            {" "}
            Nigerian policymakers, business leaders, development partners, and
            members of the diaspora{" "}
          </b>{" "}
          to discuss how{" "}
          <b className=" font-areaBlack">
            {" "}
            investments in childcare, eldercare, and household support
          </b>{" "}
          can transform families' wellbeing, unlock women's economic power, and
          catalyze inclusive growth.
        </Typography>
      </Box>

      <Grid
        container
        spacing={3}
        className="flex py-8 px-2 items-center justify-center overflow-hidden"
      >
        <Grid item={true} xs={12} sm={12} md={6} lg={6}>
          <Box className=" md:p-10 ">
            <img
              src="https://mh-resources-production.s3.us-west-1.amazonaws.com/care_infrastructure1.png"
              alt="Event Paper"
              className=" mx-auto  rounded-2xl object-cover"
            />
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={12} md={6} lg={6}>
          <Typography
            variant="subtitle1"
            fontSize={{ xs: "28px", md: "40px" }}
            lineHeight="120.5%"
            letterSpacing="-0.04em"
            mb={2}
          >
            Together, we'll chart a path toward a robust care economy that
            sustains families and strengthens Nigeria's leadership in gender
            equity and development.
          </Typography>
        </Grid>
      </Grid>

      {/* <ImageGrid
        title=""
        demoClass="hidden"
        urlClass="hidden"
        order="order-last lg:order-first"
        imgSrc="https://mh-resources-production.s3.us-west-1.amazonaws.com/Caring+Africa+UNGA.png"
        content={`
            Together, we’ll chart a path toward a robust care economy that sustains families and strengthens Nigeria's leadership in gender equity and development.
          `}
        content2="hidden"
      /> */}

      <MHSubscribe />

      <MHFooter />

      <RegDialog
        segmentId="68ced0964d2db45f46dacc41"
        firebaseId="caf-event-build-ng_care"
        open={open}
        onClose={handleClose}
      />
    </React.Fragment>
  );
};

export default BlankEvent;
